import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AdminService } from 'app/admin/admin.service';
import { FreshAuthService } from '../fresh-auth.services';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'wl-view-summary',
  templateUrl: './view-summary.component.html',
  styles: [
    `
    .center-aligned{
      text-align:center;
    }
    `
  ],
  providers: [DatePipe],
})
export class ViewSummaryComponent implements OnInit {
  filterTableDate = new Date();
  formatFilterTableDate: any = new DatePipe('en-US').transform(this.filterTableDate, 'y-MM');
  subheading1: any;
  subheading2: any;
  selectedStartDate: any;
  selectedEndDate: any;
  dateInMs: number;
  endDateInMs: number;
  showSelectedDate: boolean;
  selectedDate: any;
  allUsers: any = [];
  roleId: string;
  startDate: string;
  todayDate: string;
  dateRange: any;
  isCoLogin: boolean = false;
  showSummary: boolean = true;
  loading: boolean = false;

  constructor(
    private adminservice: AdminService,
    private customer: FreshAuthService,
    private activatedRoute: ActivatedRoute,
    private snackbar: MatSnackBar,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    this.roleId = this.customer.getRoleId();
    if (this.roleId == '1') {
      this.isCoLogin = true;
      this.showSummary = false;
    }

    this.subheading1 = this.adminservice.getBranchName();
    this.subheading2 = this.adminservice.getSolID();
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.startDate = this.datePipe.transform(startOfMonth, 'yyyy-MM-dd');
    this.todayDate = this.datePipe.transform(today, 'yyyy-MM-dd');
    let startDateConvert = this.startDate.split('-').reverse().join('-');
    let endDateConvert = this.todayDate.split('-').reverse().join('-');
    console.log(this.startDate, this.todayDate)
    // this.loading = true;
    !this.isCoLogin &&
      this.customer
        .getSummaryFilterDate(this.roleId, startDateConvert, endDateConvert, 'dateRange')
        .subscribe((res) => {
          this.loading = false;
          console.log(res);
          if (res && res.result) {
            this.allUsers = res.result ? res.result : '';
          } else {
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        });

  }

  onDateRangeSelected(dateRange: any) {
    this.loading = true;
    this.selectedStartDate = dateRange.startDate;
    this.selectedEndDate = dateRange.endDate;
    console.log(dateRange.startDate, dateRange.endDate);
    let date = new Date(this.selectedStartDate);
    this.dateInMs = date.getTime();
    let storeEnddate = new Date(this.selectedEndDate);
    this.endDateInMs = storeEnddate.getTime();
    console.log('check date', this.endDateInMs);
    if (this.dateInMs <= this.endDateInMs) {
      let dateType = 'dateRange';
      this.showSelectedDate = true;
      let startDateConvert = dateRange.startDate.split('-').reverse().join('-');
      let endDateConvert = dateRange.endDate.split('-').reverse().join('-');
      console.log(startDateConvert, endDateConvert);
      this.selectedDate = startDateConvert + ' - ' + endDateConvert;
      this.customer
        .getSummaryFilterDate(this.roleId, startDateConvert, endDateConvert, dateType)
        .subscribe((res) => {
          this.loading = false;
          console.log(res);
          if (res && res.result) {
            if (res && res.result) {
              this.allUsers = res.result ? res.result : '';
            }
          } else {
            // this.allUsers = this.getEmptyArray()
            this.closeButtonClick();
            this.snackbar.open('No Applicants found. The Filter is not Applied', 'OK', {
              duration: 4000,
            });
          }
        }, (err) => {
          this.loading = false;
          this.snackbar.open("Something went wrong", "OK", { duration: 4000 })
        });
    } else {
      this.snackbar.open('Please enter the valid date', 'OK', { duration: 4000 });
    }
  }

  closeButtonClick() {
    this.selectedDate = '';
    this.showSelectedDate = false;
    this.adminservice.reloadComponent(this.activatedRoute.snapshot['_routerState'].url);
  }

  applyFilter(formData: any) {
    this.loading = true;
    this.showSummary = true;
    try {
      this.customer.getSummary(formData).subscribe((response) => {
        if (response.message === 'success' && !response.error && response.result) {
          this.allUsers = response.result;
          this.loading = false;
        } else {
          let message = response.message ? response.message : 'No Data Found!';
          this.snackbar.open(message.toUpperCase(), 'OK', {
            duration: 4000,
          });
          this.loading = false;
        }
      });
    } catch (error) {
      this.snackbar.open(error.message, 'OK', {
        duration: 4000,
      });
      this.loading = false;
    }
  }
}
